import "../../../../styles/workspace_styles/TenantAdministratorStyles/InactiveDevicesReports/InactiveDevicesReport.css";
import { thingsBoardMicroserviceUrl } from "../../../../microservices/thingsboard_microservice";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../../AppProvider";
import { InactiveDevicesReportContext } from "./InactiveDevicesReportProvider";
const InactiveDevicesReportMessageBox = ({showInactiveDevicesReportMessageBox,setShowInactiveDevicesReportMessageBox,title,message}) =>{
    if(!showInactiveDevicesReportMessageBox) return null;
    return(
        <div className="inactive-devices-report-message-box-container">
            <div className="inactive-devices-report-message-box-header">
                <h3>{title}</h3>
                <p onClick={() => setShowInactiveDevicesReportMessageBox(false)}>&#10006;</p>
            </div>
            <div className="inactive-devices-report-message-box-body">
                <p>{message}</p>
            </div>
            <div className="inactive-devices-report-message-box-buttons-container">
                <button onClick={() => setShowInactiveDevicesReportMessageBox(false)}>Okay</button>
            </div>
        </div>
    );
};
const InactiveDevicesReportDetailsTab = ({editMode,showInactiveDevicesReportDetailsTab,inactiveDevicesReportName,setInactiveDevicesReportName}) =>{
    if(!showInactiveDevicesReportDetailsTab) return null;
    return(
        <div
            className="inactive-devices-report-details-tab-container"
            style={{opacity:`${editMode? '1':'0.9'}`}}>
            <p disabled={!editMode} style={{color:`${editMode? 'black':'gray'}`}}>Name</p>
            <input
                placeholder="Enter the name of the report"
                readOnly={!editMode}
                disabled={!editMode}
                value={inactiveDevicesReportName}
                onChange={(e) => setInactiveDevicesReportName(e.target.value)}/>
        </div>
    );
};
const InactiveDevicesReportDevicesTab = ({user,logout,editMode,deviceEntries,setDeviceEntries,selectedServerUrl,showInactiveDevicesReportDevicesTab}) =>{
    const [showInactiveDevicesReportDevicesBrowser,setShowInactiveDevicesReportDevicesBrowser] = useState(false);
    useEffect(() =>{
        if(!editMode) setShowInactiveDevicesReportDevicesBrowser(false);
    },[editMode]);
    if(!showInactiveDevicesReportDevicesTab) return null;
    return(
        <div className="inactive-devices-report-devices-tab-container" style={{opacity:`${editMode? '1':'0.9'}`}}>
            <div className="inactive-devices-report-devices-controls-container">
                <p style={{color:`${editMode? 'black':'gray'}`}}>Devices</p>
                <button
                    style={{
                        cursor:`${editMode? 'pointer':'default'}`,
                        display:`${showInactiveDevicesReportDevicesBrowser? 'none':'inline-block'}`,
                        backgroundColor:`${editMode?'rgba(155, 30, 30, 0.953)':'rgb(196, 126, 126)'}`,
                        boxShadow:`${editMode? '2px 2px 4px rgba(0, 0, 0, 0.5)':'none'}`
                    }}
                    onClick={() =>{
                        if(!editMode) return;
                        setShowInactiveDevicesReportDevicesBrowser(true)
                    }}>Add</button>
            </div>
            {deviceEntries.length === 0? (
                <div
                    style={{
                        opacity:`${editMode? '1':'0.7'}`,
                        color:`${editMode? 'black':'gray'}`,
                        display:`${showInactiveDevicesReportDevicesBrowser? 'none':'block'}`
                    }}
                    className="inactive-devices-report-devices-empty-table-container">
                    <h4>Report has no devices</h4>
                    <p>Your report does not contain any devices. Please add at least one device.</p>
                </div>
            ):(
                <div className="inactive-devices-report-devices-table-container">
                    <table style={{color:`${editMode? 'black':'gray'}`}}>
                        <thead>
                            <tr id="inactive-devices-report-devices-table-header-row">
                                <th style={{width:'40%'}}>Name</th>
                                <th style={{width:'25%'}}>Date added</th>
                                <th style={{width:'25%'}}>Time added</th>
                                <th style={{width:'10%'}}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {deviceEntries.length > 0 && deviceEntries.map((deviceEntry) =>(
                                <tr key={deviceEntry.id}>
                                    <td>{deviceEntry.name}</td>
                                    <td>{deviceEntry.dateAdded}</td>
                                    <td>{deviceEntry.timeAdded}</td>
                                    <td>
                                        <img
                                            disabled={!editMode}
                                            style={{cursor:`${editMode? 'pointer':'default'}`,opacity:`${editMode? '1':'0.6'}`}}
                                            onClick={() =>{
                                                if(!editMode) return;
                                                const updatedDeviceEntries = deviceEntries.filter( entry => entry.id !== deviceEntry.id);
                                                setDeviceEntries(updatedDeviceEntries);
                                            }}
                                            src={`${process.env.PUBLIC_URL}/images/delete-icon.png`}/>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
            <InactiveDevicesReportDevicesBrowser
                user={user}
                logout={logout}
                deviceEntries={deviceEntries}
                setDeviceEntries={setDeviceEntries}
                selectedServerUrl={selectedServerUrl}
                showInactiveDevicesReportDevicesBrowser={showInactiveDevicesReportDevicesBrowser}
                setShowInactiveDevicesReportDevicesBrowser={setShowInactiveDevicesReportDevicesBrowser}
            />
        </div>
    );
};
const InactiveDevicesReportDevicesBrowser = ({
        deviceEntries,
        setDeviceEntries,
        showInactiveDevicesReportDevicesBrowser,
        setShowInactiveDevicesReportDevicesBrowser
    }) =>{
    const {user,logout} = useContext(AppContext);
    const {selectedTenantAdminProfile} = useContext(InactiveDevicesReportContext);
    const [devicesSummary,setDevicesSummary] = useState([]);
    const [selectedDeviceId,setSelectedDeviceId] = useState('');
    const fetchDevicesSummary = async() =>{
        try{
            const url = `${thingsBoardMicroserviceUrl}/tenants/profiles/${selectedTenantAdminProfile?.id}/devices?limit=50`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${user?.access_token}`,
                    'Content-Type':'application/json'
                }
            });
            if(response.status === 401) logout();
            const responseData = await response.json();
            setDevicesSummary(responseData);
        }
        catch(error){
            console.error(error);
        }
    };
    useEffect(() =>{
        if(showInactiveDevicesReportDevicesBrowser){
            fetchDevicesSummary();
            setSelectedDeviceId('');
        }
    },[showInactiveDevicesReportDevicesBrowser]);
    if(!showInactiveDevicesReportDevicesBrowser) return null;
    return(
        <div className="inactive-devices-report-devices-browser-container">
            <div className="inactive-devices-report-devices-browser-header">
                <h3>Add device</h3>
                <p onClick={() => setShowInactiveDevicesReportDevicesBrowser(false)}>&#10006;</p>
            </div>
            <div className="inactive-devices-report-devices-browser-body">
                <select value={selectedDeviceId} onChange={(e) => setSelectedDeviceId(e.target.value)}>
                    <option value='' disabled>Select device</option>
                    {devicesSummary && devicesSummary.length > 0 && devicesSummary.map(deviceSummary =>{
                        const isDeviceInEntries = deviceEntries.some(entry => entry.id === deviceSummary.id);
                        if(isDeviceInEntries) return null;
                        return(<option key={deviceSummary.name} value={deviceSummary.id}>{deviceSummary.name}</option>);
                    })}
                </select>
            </div>
            <div className="inactive-devices-report-devices-browser-add-button-container">
                <button onClick={() =>{
                    if(selectedDeviceId === '') return;
                    const selectedDevice = devicesSummary.find(device => device.id === selectedDeviceId);
                    if(!selectedDevice) return;
                    const addedDate = new Date();
                    const day = addedDate.getDate();
                    const month = addedDate.getMonth() + 1;
                    const year = addedDate.getFullYear();
                    const dateAdded = `${day > 9? '':'0'}${day}-${month > 9? '':'0'}${month}-${year}`;
                    const timeAdded = addedDate.toLocaleTimeString('en-GB');
                    setDeviceEntries((prevDeviceEntries) => [...prevDeviceEntries,{
                        id:selectedDevice.id,
                        name:selectedDevice.name,
                        dateAdded:dateAdded,
                        timeAdded:timeAdded
                    }]);
                    setShowInactiveDevicesReportDevicesBrowser(false);
                }}>Add</button>
            </div>
        </div>
    );
};
const InactiveDevicesReportScheduleTab = ({editMode,scheduleEntries,setScheduleEntries,showInactiveDevicesReportScheduleTab}) =>{
    const [showReportScheduleEntry,setShowReportScheduleEntry] = useState(false);
    const [selectedReportScheduleEntry,setSelectedReportScheduleEntry] = useState(null);
    const [showEditReportScheduleEntry,setShowEditReportScheduleEntry] = useState(false);
    useEffect(() =>{
        if(!editMode) setShowReportScheduleEntry(false);
    },[editMode]);
    if(!showInactiveDevicesReportScheduleTab) return null;
    return(
        <div className="inactive-devices-report-schedule-tab-container">
            <div className="inactive-devices-report-schedule-controls-container">
                <p style={{color:`${editMode? 'black':'gray'}`}}>Schedule</p>
                <button
                    style={{
                        cursor:`${editMode? 'pointer':'default'}`,
                        display:`${showReportScheduleEntry? 'none':'inline-block'}`,
                        backgroundColor:`${editMode?'rgba(155, 30, 30, 0.953)':'rgb(196, 126, 126)'}`,
                        boxShadow:`${editMode? '2px 2px 4px rgba(0, 0, 0, 0.5)':'none'}`
                    }}
                    onClick={() => {
                        if(!editMode) return;
                        setShowReportScheduleEntry(true);
                    }}>
                    Add
                </button>
            </div>
            {scheduleEntries.length === 0? (
                <div
                    style={{
                        opacity:`${editMode? '1':'0.7'}`,
                        color:`${editMode? 'black':'gray'}`,
                        display:`${showReportScheduleEntry?'none':'block'}`
                    }}
                    className="inactive-devices-report-schedule-entries-empty-table-container">
                    <h4>Report has no schedules</h4>
                    <p>Your report does not contain any schedules. Please add at least one schedule.</p>
                </div>
            ):(
                <div className="inactive-devices-report-schedule-entries-table-container">
                    <table style={{color:`${editMode? 'black':'gray'}`}}>
                        <thead>
                            <tr id="inactive-devices-report-schedule-entries-table-header-row">
                                <th>Frequency</th>
                                <th>Time</th>
                                <th>Inactivity threshold</th>
                                <th style={{textAlign:'center'}}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {scheduleEntries && scheduleEntries.length > 0 && scheduleEntries.map((scheduleEntry,scheduleEntryIndex) =>(
                                <tr key={scheduleEntryIndex}>
                                    <td>{scheduleEntry.frequency}</td>
                                    <td>{scheduleEntry.time}</td>
                                    <td>{scheduleEntry.inactivityThreshold? `${
                                        scheduleEntry.inactivityThreshold == 0.5? 
                                        '30 minutes':`${scheduleEntry.inactivityThreshold} Hour${scheduleEntry.inactivityThreshold === 1? '':'s'}`
                                    }`:''}</td>
                                    <td>
                                        <div>
                                            <div
                                                disabled={!editMode}
                                                onClick={() =>{
                                                    setSelectedReportScheduleEntry(scheduleEntry);
                                                    setShowEditReportScheduleEntry(true);
                                                }}>
                                                <img
                                                    style={{cursor:`${editMode? 'pointer':'default'}`,opacity:`${editMode? '1':'0.6'}`}}
                                                    src={`${process.env.PUBLIC_URL}/images/edit-icon.png`} title="Edit schedule entry"
                                                />
                                            </div>
                                            <div
                                                disabled={!editMode}
                                                onClick={() =>{
                                                    if(!editMode) return;
                                                    const updatedScheduleEntries = scheduleEntries.filter((_,index) => index !== scheduleEntryIndex);
                                                    setScheduleEntries(updatedScheduleEntries);
                                                }}>
                                                <img
                                                    style={{cursor:`${editMode? 'pointer':'default'}`,opacity:`${editMode? '1':'0.6'}`}}
                                                    src={`${process.env.PUBLIC_URL}/images/delete-icon.png`} title="Delete shedule entry"
                                                />
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
            <ReportScheduleEntry
                showReportScheduleEntry={showReportScheduleEntry}
                setShowReportScheduleEntry={setShowReportScheduleEntry}
                setScheduleEntries={setScheduleEntries}
            />
            <EditReportScheduleEntry
                scheduleEntry={selectedReportScheduleEntry}
                setScheduleEntry={setSelectedReportScheduleEntry}
                scheduleEntries={scheduleEntries}
                setScheduleEntries={setScheduleEntries}
                showEditReportScheduleEntry={showEditReportScheduleEntry}
                setShowEditReportScheduleEntry={setShowEditReportScheduleEntry}
            />
        </div>
    );
};
const ReportScheduleEntry = ({showReportScheduleEntry,setShowReportScheduleEntry,setScheduleEntries}) =>{
    const [scheduleFrequency,setScheduleFrequency] = useState('Every day');
    const [scheduleTime,setScheduleTime] = useState('07:00');
    const [inactivityThreshold,setInactivityThreshold] = useState(1);
    useEffect(() => {
        if(showReportScheduleEntry){
            setScheduleFrequency('Every day');
            setScheduleTime('07:00');
            setInactivityThreshold(1);
        }
    },[showReportScheduleEntry]);
    if(!showReportScheduleEntry) return null;
    return(
        <div className="report-schedule-entry-container">
            <div className="report-schedule-entry-header">
                <h4>Add schedule</h4>
                <p onClick={() => setShowReportScheduleEntry(false)}>&#10006;</p>
            </div>
            <div className="report-schedule-frequency-entry-container">
                <p>Frequency</p>
                <select value={scheduleFrequency} onChange={(e) => setScheduleFrequency(e.target.value)}>
                    <option value='Every day'>Every day</option>
                    <option value='Every Monday'>Every Monday</option>
                    <option value='Every Tuesday'>Every Tuesday</option>
                    <option value='Every Wednesday'>Every Wednesday</option>
                    <option value='Every Thursday'>Every Thursday</option>
                    <option value='Every Friday'>Every Friday</option>
                    <option value='Every Saturday'>Every Saturday</option>
                    <option value='Every Sunday'>Every Sunday</option>
                </select>
            </div>
            <div className="report-schedule-time-entry-container">
                <p>Time</p>
                <input value={scheduleTime} type="time" onChange={(e) => setScheduleTime(e.target.value)}/>
            </div>
            <div className="report-schedule-inactivity-threshold-entry-container">
                <p>Inactivity threshold</p>
                <select value={inactivityThreshold} onChange={(e) => setInactivityThreshold(e.target.value)}>
                    <option value={0.5}>30 Minutes</option>
                    <option value={1}>1 Hour</option>
                    <option value={2}>2 Hours</option>
                    <option value={3}>3 Hours</option>
                    <option value={4}>4 Hours</option>
                    <option value={5}>5 Hours</option>
                    <option value={6}>6 Hours</option>
                    <option value={7}>7 Hours</option>
                    <option value={8}>8 Hours</option>
                    <option value={9}>9 Hours</option>
                    <option value={10}>10 Hours</option>
                    <option value={11}>11 Hours</option>
                    <option value={12}>12 Hours</option>
                </select>
            </div>
            <div className="report-schedule-add-button-container">
                <button onClick={() =>{
                    setScheduleEntries((prevSchedules) => [...prevSchedules,{
                        id:null,
                        frequency:scheduleFrequency,
                        time:`${scheduleTime}:00`,
                        inactivityThreshold:inactivityThreshold
                    }]);
                    setShowReportScheduleEntry(false);
                }}>Add</button>
            </div>
        </div>
    );
};
const EditReportScheduleEntry = ({showEditReportScheduleEntry,setShowEditReportScheduleEntry,scheduleEntry,setScheduleEntry,scheduleEntries,setScheduleEntries}) => {
    const [scheduleFrequency,setScheduleFrequency] = useState('Every day');
    const [scheduleTime,setScheduleTime] = useState('07:00:00');
    const [inactivityThreshold,setInactivityThreshold] = useState(1);
    useEffect(() =>{
        if(showEditReportScheduleEntry){
            if(scheduleEntry){
                setScheduleFrequency(scheduleEntry.frequency);
                setScheduleTime(scheduleEntry.time);
                setInactivityThreshold(scheduleEntry.inactivityThreshold);
            }
        }
        else setScheduleEntry(null);
    },[showEditReportScheduleEntry]);
    const updateSelectedEntry =() => {
        const updatedScheduleEntries = scheduleEntries.map((entry,index) =>{
            if(entry.frequency === scheduleEntry.frequency && entry.time === scheduleEntry.time && entry.inactivityThreshold === scheduleEntry.inactivityThreshold){
                return{
                    ...entry,
                    id:scheduleEntry.id? scheduleEntry.id:null,
                    frequency:scheduleFrequency,
                    time:`${scheduleTime}:00`,
                    inactivityThreshold: inactivityThreshold
                };
            }
            else return entry;
        });
        setScheduleEntries(updatedScheduleEntries);
    };
    if(!showEditReportScheduleEntry || !scheduleEntry) return null;
    return(
        <div className="report-schedule-entry-container">
            <div className="report-schedule-entry-header">
                <h4>Add schedule</h4>
                <p onClick={() => setShowEditReportScheduleEntry(false)}>&#10006;</p>
            </div>
            <div className="report-schedule-frequency-entry-container">
                <p>Frequency</p>
                <select value={scheduleFrequency} onChange={(e) => setScheduleFrequency(e.target.value)}>
                    <option value='Every day'>Every day</option>
                    <option value='Every Monday'>Every Monday</option>
                    <option value='Every Tuesday'>Every Tuesday</option>
                    <option value='Every Wednesday'>Every Wednesday</option>
                    <option value='Every Thursday'>Every Thursday</option>
                    <option value='Every Friday'>Every Friday</option>
                    <option value='Every Saturday'>Every Saturday</option>
                    <option value='Every Sunday'>Every Sunday</option>
                </select>
            </div>
            <div className="report-schedule-time-entry-container">
                <p>Time</p>
                <input value={scheduleTime} type="time" onChange={(e) => setScheduleTime(e.target.value)}/>
            </div>
            <div className="report-schedule-inactivity-threshold-entry-container">
                <p>Inactivity threshold</p>
                <select value={inactivityThreshold} onChange={(e) => setInactivityThreshold(e.target.value)}>
                    <option value={0.5}>30 Minutes</option>
                    <option value={1}>1 Hour</option>
                    <option value={2}>2 Hours</option>
                    <option value={3}>3 Hours</option>
                    <option value={4}>4 Hours</option>
                    <option value={5}>5 Hours</option>
                    <option value={6}>6 Hours</option>
                    <option value={7}>7 Hours</option>
                    <option value={8}>8 Hours</option>
                    <option value={9}>9 Hours</option>
                    <option value={10}>10 Hours</option>
                    <option value={11}>11 Hours</option>
                    <option value={12}>12 Hours</option>
                </select>
            </div>
            <div className="report-schedule-add-button-container">
                <button onClick={() =>{
                    updateSelectedEntry();
                    setShowEditReportScheduleEntry(false);
                }}>Update</button>
            </div>
        </div>
    );
};
const InactiveDevicesReportRecipientsTab = ({editMode,recipients,setRecipients,showInactiveDevicesReportRecipientsTab}) =>{
    const [showNewInactiveDevicesReportNewRecipientEntry,setShowNewInactiveDevicesReportNewRecipientEntry] = useState(false);
    useEffect(() =>{
        if(!editMode) setShowNewInactiveDevicesReportNewRecipientEntry(false);
    },[editMode]);
    if(!showInactiveDevicesReportRecipientsTab) return null;
    return(
        <div className="inactive-devices-report-recipients-tab-container">
            <div className="inactive-devices-report-recipients-controls-container">
                <p style={{color:`${editMode? 'black':'gray'}`}}>Recipients</p>
                <button
                    style={{
                        cursor:`${editMode? 'pointer':'default'}`,
                        display:`${showNewInactiveDevicesReportNewRecipientEntry? 'none':'inline-block'}`,
                        backgroundColor:`${editMode?'rgba(155, 30, 30, 0.953)':'rgb(196, 126, 126)'}`,
                        boxShadow:`${editMode? '2px 2px 4px rgba(0, 0, 0, 0.5)':'none'}`
                    }}
                    onClick={() => {
                        if(!editMode) return;
                        setShowNewInactiveDevicesReportNewRecipientEntry(true);
                    }}>Add</button>
            </div>
            {recipients.length === 0? (
                <div
                    style={{
                        opacity:`${editMode? '1':'0.7'}`,
                        color:`${editMode? 'black':'gray'}`,
                        display:`${showNewInactiveDevicesReportNewRecipientEntry?'none':'block'}`
                    }}
                    className="inactive-devices-report-recipients-empty-table-container">
                    <h4>Report has no recipients</h4>
                    <p>Your report does not contain any recipients. Please add at least one recipient.</p>
                </div>):(
                <div className="inactive-devices-report-recipients-table-container">
                    <table style={{color:`${editMode? 'black':'gray'}`}}>
                        <thead>
                            <tr id="inactive-devices-report-recipients-table-header-row">
                                <th style={{width:'20%'}}>Name</th>
                                <th style={{width:'35%'}}>Email address</th>
                                <th style={{width:'17%'}}>Date added</th>
                                <th style={{width:'17%'}}>Time added</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {recipients.length > 0 && recipients.map((recipient,recipientIndex) => (
                                <tr key={recipientIndex}>
                                    <td>{recipient.name}</td>
                                    <td>{recipient.emailAddress}</td>
                                    <td>{recipient.dateAdded}</td>
                                    <td>{recipient.timeAdded}</td>
                                    <td>
                                        <img
                                            style={{cursor:`${editMode? 'pointer':'default'}`,opacity:`${editMode? '1':'0.6'}`}}
                                            onClick={() =>{
                                                if(!editMode) return;
                                                const updatedRecipients = recipients.filter((_,index) => index !== recipientIndex);
                                                setRecipients(updatedRecipients);
                                            }}
                                            src={`${process.env.PUBLIC_URL}/images/delete-icon.png`}
                                            title="Delete recipient"
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
            <InactiveDevicesReportNewRecipientEntry
                recipients={recipients}
                setRecipients={setRecipients}
                showNewInactiveDevicesReportNewRecipientEntry={showNewInactiveDevicesReportNewRecipientEntry}
                setShowNewInactiveDevicesReportNewRecipientEntry={setShowNewInactiveDevicesReportNewRecipientEntry}
            />
        </div>
    );
};
const InactiveDevicesReportNewRecipientEntry = ({
        recipients,
        setRecipients,
        showNewInactiveDevicesReportNewRecipientEntry,
        setShowNewInactiveDevicesReportNewRecipientEntry
    }) =>{
    const [recipientName,setRecipientName] = useState('');
    const [recipientEmailAddress,setRecipientEmailAddress] = useState('');
    useEffect(() =>{
        if(showNewInactiveDevicesReportNewRecipientEntry){
            setRecipientName('');
            setRecipientEmailAddress('');
        }
    },[showNewInactiveDevicesReportNewRecipientEntry])
    if(!showNewInactiveDevicesReportNewRecipientEntry) return null;
    return(
        <div className="inactive-devices-report-new-recipient-entry-container">
            <div className="inactive-devices-report-new-recipient-entry-header">
                <h3>New recipient</h3>
                <p onClick={() => setShowNewInactiveDevicesReportNewRecipientEntry(false)}>&#10006;</p>
            </div>
            <div className="inactive-devices-report-new-recipient-entry-body">
                <div className="inactive-devices-report-new-recipient-name-container">
                    <p>Name</p>
                    <input value={recipientName} onChange={(e) => setRecipientName(e.target.value.replace(/\s/g,''))}/>
                </div>
                <div className="inactive-devices-report-new-recipient-email-address-container">
                    <p>Email address</p>
                    <input value={recipientEmailAddress} onChange={(e) => setRecipientEmailAddress(e.target.value.replace(/\s/g,''))}/>
                </div>
                <div className="inactive-devices-report-new-recipient-add-button-container">
                    <button onClick={() =>{
                        if(recipientName === '') window.alert("Enter recipient's name");
                        else if(recipientEmailAddress === '') window.alert("Enter recipient's email address");
                        else{
                            const addedDate = new Date();
                            const day = addedDate.getDate();
                            const month = addedDate.getMonth() + 1;
                            const year = addedDate.getFullYear();
                            const dateAdded = `${day > 9? '':'0'}${day}-${month > 9? '':'0'}${month}-${year}`;
                            const timeAdded = addedDate.toLocaleTimeString('en-GB');
                            setRecipients([...recipients,{
                                id:null,
                                name:recipientName,
                                emailAddress:recipientEmailAddress,
                                dateAdded:dateAdded,
                                timeAdded:timeAdded
                            }])
                            setShowNewInactiveDevicesReportNewRecipientEntry(false);
                        }
                    }}>Add</button>
                </div>
            </div>
        </div>
    );
};
const InactiveDevicesReport = ({
    selectedServerUrl,
    showInactiveDevicesReport,
    setShowInactiveDevicesReport,
    inactiveDevicesReportId}) =>{
    const {user,logout} = useContext(AppContext);
    const {selectedTenantAdminProfile} = useContext(InactiveDevicesReportContext);
    const [showInactiveDevicesReportDetailsTab,setShowInactiveDevicesReportDetailsTab] = useState(false);
    const [showInactiveDevicesReportDevicesTab,setShowInactiveDevicesReportDevicesTab] = useState(false);
    const [showInactiveDevicesReportScheduleTab,setShowInactiveDevicesReportScheduleTab] = useState(false);
    const [showInactiveDevicesReportRecipientsTab,setShowInactiveDevicesReportRecipientsTab] = useState(false);
    const [showInactiveDevicesReportMessageBox,setShowInactiveDevicesReportMessageBox] = useState(false);
    const [inactiveDevicesReport,setInactiveDevicesReport] = useState(null);
    const [inactiveDevicesReportName,setInactiveDevicesReportName] = useState('');
    const [deviceEntries,setDeviceEntries] = useState([]);
    const [scheduleEntries,setScheduleEntries] = useState([]);
    const [recipients,setRecipients] = useState([]);
    const [editMode,setEditMode] = useState(false);
    const [inactiveDevicesReportMessageBoxMessage,setInactiveDevicesReportMessageBoxMessage] = useState('');
    const [inactiveDevicesReportMessageBoxTitle,setInactiveDevicesReportMessageBoxTitle] = useState('');
    const fetchInactiveDevicesReport = async() =>{
        try{
            if(!inactiveDevicesReportId) return;
            const url = `${thingsBoardMicroserviceUrl}/tenants/profiles/${selectedTenantAdminProfile?.id}/devices/inactive/reports/${inactiveDevicesReportId}`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${user.access_token}`,
                    'Content-Type':'application/json'
                }
            });
            if(response.ok){
                const responseData = await response.json();
                if(!responseData) throw new Error('Response was not valid');
                setInactiveDevicesReport(responseData);
                setInactiveDevicesReportName(responseData.name);
                setDeviceEntries(responseData.devices);
                setScheduleEntries(responseData.schedules);
                setRecipients(responseData.recipients);
            }
            else throw new Error(response.status);
        }
        catch(error){
            console.error(error);
        }
    };
    const ShowInactiveDevicesReportMessageBox = (title,message) =>{
        setInactiveDevicesReportMessageBoxTitle(title);
        setInactiveDevicesReportMessageBoxMessage(message);
        setShowInactiveDevicesReportMessageBox(true);
    };
    useEffect(() =>{
        if(!showInactiveDevicesReport || !inactiveDevicesReportId){
            setInactiveDevicesReportName('');
            setDeviceEntries([]);
            setScheduleEntries([]);
            setRecipients([]);
            setInactiveDevicesReport(null);
            setEditMode(false);
        }
        setShowInactiveDevicesReportDevicesTab(false);
        setShowInactiveDevicesReportScheduleTab(false);
        setShowInactiveDevicesReportRecipientsTab(false);
        setShowInactiveDevicesReportDetailsTab(true);
        fetchInactiveDevicesReport();
    },[showInactiveDevicesReport]);
    const updateInactiveDevicesReport = async(updatedInactiveDevicesReport) =>{
        try{
            const url = `${thingsBoardMicroserviceUrl}/tenants/profiles/${selectedTenantAdminProfile?.id}/devices/inactive/reports/${inactiveDevicesReportId}`;
            const response = await fetch(url,{
                method:'PATCH',
                headers:{
                    'Authorization':`Bearer ${user.access_token}`,
                    'Content-Type':'application/json'
                },
                body: JSON.stringify(updatedInactiveDevicesReport)
            });
            if(response.ok){
                const responseData = await response.json();
                await fetchInactiveDevicesReport();
                ShowInactiveDevicesReportMessageBox('Success','Inactive devices report updated successfully');
            }
            else throw new Error(response.status);
        }
        catch(error){
            console.error('An error occurred when updating inactive devices report: ',error);
            ShowInactiveDevicesReportMessageBox('Error','An error occurred when updating inactive devices report');
        }
    };
    if(!showInactiveDevicesReport) return null;
    return(
        <div className="inactive-devices-report-container">
            <div className="inactive-devices-report-header">
                <div>
                    <h3>{`${inactiveDevicesReport? inactiveDevicesReport.name:'Loading...'}`}</h3>
                    <h4>Inactive devices report details</h4>
                </div>
                <div>
                    <p onClick={() =>{
                        setInactiveDevicesReport(null);
                        setShowInactiveDevicesReport(false);
                    }}>&#10006;</p>
                </div>
            </div>
            <div className="inactive-devices-report-navigation-bar">
                <div className="inactive-devices-report-tab-navigation-bar">
                    <div className="inactive-devices-report-schedule-button-container">
                        <button onClick={() =>{
                            setShowInactiveDevicesReportDevicesTab(false);
                            setShowInactiveDevicesReportScheduleTab(false);
                            setShowInactiveDevicesReportRecipientsTab(false);
                            setShowInactiveDevicesReportDetailsTab(true);
                        }}
                        style={{
                            backgroundColor:`${showInactiveDevicesReportDetailsTab? 'rgb(169,169,169)':'white'}`
                        }}>Details</button>
                    </div>
                    <div className="inactive-devices-report-schedule-button-container">
                        <button onClick={() =>{
                            setShowInactiveDevicesReportDetailsTab(false);
                            setShowInactiveDevicesReportScheduleTab(false);
                            setShowInactiveDevicesReportRecipientsTab(false);
                            setShowInactiveDevicesReportDevicesTab(true);
                        }}
                        style={{
                            backgroundColor:`${showInactiveDevicesReportDevicesTab? 'rgb(169,169,169)':'white'}`
                        }}>Devices</button>
                    </div>
                    <div className="inactive-devices-report-devices-button-container">
                        <button onClick={() =>{
                            setShowInactiveDevicesReportDetailsTab(false);
                            setShowInactiveDevicesReportDevicesTab(false);
                            setShowInactiveDevicesReportRecipientsTab(false);
                            setShowInactiveDevicesReportScheduleTab(true);
                        }}
                        style={{
                            backgroundColor:`${showInactiveDevicesReportScheduleTab?'rgb(169,169,169)':'white'}`
                        }}>Schedule</button>
                    </div>
                    <div className="inactive-devices-report-recipients-button-container">
                        <button onClick={() =>{
                            setShowInactiveDevicesReportDetailsTab(false);
                            setShowInactiveDevicesReportDevicesTab(false);
                            setShowInactiveDevicesReportScheduleTab(false);
                            setShowInactiveDevicesReportRecipientsTab(true);
                        }}
                        style={{
                            backgroundColor:`${showInactiveDevicesReportRecipientsTab?'rgb(169,169,169)':'white'}`
                        }}>Recipients</button>
                    </div>
                </div>
                <div className="inactive-devices-report-edit-controls">
                    <button
                        className="inactive-devices-report-save-changes-button"
                        style={{display:`${editMode? 'inline-block':'none'}`}}
                        onClick={async() =>{
                            if(inactiveDevicesReportName.length === 0){
                                window.alert('Enter the updated name of the inactive devices report');
                                return;
                            }
                            else if(deviceEntries.length === 0){
                                window.alert('At least one device is required');
                                return;
                            }
                            else if(scheduleEntries.length === 0){
                                window.alert('At least one schedule is required');
                                return;
                            }
                            else if(recipients.length === 0){
                                window.alert('At least one recipient is required');
                                return;
                            }
                            else{
                                const updatedInactiveDevicesReport = {
                                    name:inactiveDevicesReportName,
                                    devices:deviceEntries,
                                    schedules:scheduleEntries,
                                    recipients:recipients,
                                };
                                await updateInactiveDevicesReport(updatedInactiveDevicesReport);
                                setEditMode(false);
                            }
                        }}>&#10003;</button>
                    <button
                        className="inactive-devices-report-discard-changes-button"
                        style={{display:`${editMode? 'inline-block':'none'}`}}
                        onClick={async() => {
                            setEditMode(false);
                            await fetchInactiveDevicesReport();
                        }}>&#10006;</button>
                    <button
                        className="inactive-devices-report-edit-button"
                        style={{display:`${editMode? 'none':'inline-block'}`}}
                        onClick={() =>setEditMode(true)}>
                        <img src={`${process.env.PUBLIC_URL}/images/edit-icon.png`}/>
                    </button>
                </div>
            </div>
            <div className="inactive-devices-report-body">
                <InactiveDevicesReportDetailsTab
                    editMode={editMode}
                    showInactiveDevicesReportDetailsTab={showInactiveDevicesReportDetailsTab}
                    inactiveDevicesReportName={inactiveDevicesReportName}
                    setInactiveDevicesReportName={setInactiveDevicesReportName}
                />
                <InactiveDevicesReportDevicesTab
                    user={user}
                    logout={logout}
                    editMode={editMode}
                    deviceEntries={deviceEntries}
                    setDeviceEntries={setDeviceEntries}
                    selectedServerUrl={selectedServerUrl}
                    showInactiveDevicesReportDevicesTab={showInactiveDevicesReportDevicesTab}
                />
                <InactiveDevicesReportScheduleTab
                    editMode={editMode}
                    scheduleEntries={scheduleEntries}
                    setScheduleEntries={setScheduleEntries}
                    showInactiveDevicesReportScheduleTab={showInactiveDevicesReportScheduleTab}
                />
                <InactiveDevicesReportRecipientsTab
                    editMode={editMode}
                    recipients={recipients}
                    setRecipients={setRecipients}
                    showInactiveDevicesReportRecipientsTab={showInactiveDevicesReportRecipientsTab}
                />
            </div>
            <InactiveDevicesReportMessageBox
                showInactiveDevicesReportMessageBox={showInactiveDevicesReportMessageBox}
                setShowInactiveDevicesReportMessageBox={setShowInactiveDevicesReportMessageBox}
                title={inactiveDevicesReportMessageBoxTitle}
                message={inactiveDevicesReportMessageBoxMessage}
            />
        </div>
    );
};
export default InactiveDevicesReport;